export const GET_VARIETIES = 'varieties/GET_VARIETIES';
export const GET_VARIETIES_SUCCESS = 'varieties/GET_VARIETIES_SUCCESS';
export const GET_VARIETIES_FAILED = 'varieties/GET_VARIETIES_FAILED';